import { http } from '@/http'

// const PATH = 'app/docs/'
const PATH = ''

class AsosService {
  static async getAllMedicos () {
    return http.get(PATH.concat('medicos'))
  }

  static async getAllCities () {
    return http.get(PATH.concat('cidades'))
  } 

  static async getAllPacientes () {
    return http.get(PATH.concat('pacientes'))
  }

  static async getAllSchedules () {
    return http.get(PATH.concat('medicos/schedules'))
  }

  static async getEmployeesByCombo () {
    return http.get(PATH.concat('employees'))
  }

  static async getAfastamentoCombo () {
    return http.get(PATH.concat('afastamento-combo'))
  }

  static async registrarConsulta (itensBody) {
    return http.post(PATH.concat('medicos/consulta'), itensBody)
  }
  
  static async registrarMedico (itensBody) {
    return http.post(PATH.concat('medicos'), itensBody)
  }
  

}

export default AsosService
